import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { CONTENT } from '../data/content';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem('alhilal-lang') || 'ar';
    } catch {
      return 'ar';
    }
  });

  const t = CONTENT[lang];

  useEffect(() => {
    document.documentElement.lang = t.lang;
    document.documentElement.dir = t.dir;
    try {
      localStorage.setItem('alhilal-lang', lang);
    } catch {
      // ignore storage failures (private mode, etc.)
    }
  }, [lang, t]);

  const value = useMemo(
    () => ({
      lang,
      t,
      toggleLang: () => setLang((l) => (l === 'ar' ? 'en' : 'ar')),
    }),
    [lang, t]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
